import { Rows } from "../../interfaces";
import { getHeaders, getHeadersForCurrentCompany } from "./headers";
import { dashInsteadOfNullCommon, formats, getCell, withCellStyles } from "../../utils";
import { centeredBoldGrayForHeaders, left, leftIntend } from "src/app/util/excelStyles";
import { bold } from "../financial-statement/capital-account/styles";
import { StockDTO } from '../../../company-performance/companies-stocks/dto/StockDTO';
import {
  StockInnerCompanyDTO,
} from '../../../company-performance/companies-stocks/sub/company-stocks/company-stocks-inner.component';
import {
  CompanyComparableValuationExcelExportData,
} from '../../../company-performance/companies-stocks/dto/StockAuxiliary';

export const getPreparedData = (data: CompanyComparableValuationExcelExportData): Rows => {
  const newData: Rows = [];
  headersForDisplay = getHeaders();

  headersForCurrentCompany = getHeadersForCurrentCompany();

  newData.push(headersForCurrentCompany);

  const currentCompanyRow = getCurrentCompanyDataRow(data.currentCompany);
  newData.push(...currentCompanyRow);
  newData.push(['']);
  currentRowIndex++;

  newData.push([withCellStyles('Comparable companies', bold)]);
  currentRowIndex++;

  const secondHeaderRow = [];
  headersForDisplay.forEach((header) => secondHeaderRow.push(withCellStyles(header, centeredBoldGrayForHeaders)));
  newData.push(secondHeaderRow);
  currentRowIndex++;

  const mainRows = getMainRows(data.stocks);
  newData.push(...mainRows);
  resetData();
  return newData;
};

const getMainRows = (data: StockDTO[]): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = data.map((stock) => getNewMapping(stock));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headersForDisplay) {
      if (header === 'Company name' || header === 'Ticker') {
        row.push(withCellStyles(mapped[header], leftIntend));
      } else {
        row.push(withCellStyles(mapped[header], left));
      }
    }
    rows.push(row);
  }
  return rows;
};

const getNewMapping = (stock: StockDTO): object => {
  const body = {
    'Company name': stock.name,
    Ticker: stock.tickerName,
    'Enterprise value': getCell({
      v: dashInsteadOfNullCommon(stock.enterpriseValue),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Revenue (TTM)': getCell({
      v: dashInsteadOfNullCommon(stock.revenueTTM),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'EV/Revenue': getCell({
      f: `IFERROR(D${currentRowIndex}/E${currentRowIndex},"-")`,
      z: formats.toFixed2,
      t: 'n',
    }),
    'As of': stock.dataAsOf,
    Description: stock.description,
  };
  currentRowIndex++;
  return body;
};

const getCurrentCompanyDataRow = (current: StockInnerCompanyDTO): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = getNewMappingForCurrentCompany(current);
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headersForCurrentCompany) {
      if (header === 'Company name' || header === 'Ticker') {
        row.push(withCellStyles(mapped[header], leftIntend));
      } else {
        row.push(withCellStyles(mapped[header], left));
      }
    }
    rows.push(row);
  }
  return rows;
};

const getNewMappingForCurrentCompany = (current: StockInnerCompanyDTO): object[] => {
  const body = {
    'Company name': current.companyName,
    'Annual revenue': getCell({
      v: dashInsteadOfNullCommon(current.annualRevenue),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'As of': current.dataAsOf,
    'Average market ratio': getCell({
      v: dashInsteadOfNullCommon(current.averageRatio),
      z: formats.toFixed2,
      t: 'n',
    }),
    'Discount rate': getCell({
      v: dashInsteadOfNullCommon(current.discountRate),
      z: formats.percents,
      t: 'n',
    }),
    'Company value': getCell({
      f: `E${currentRowIndex}*C${currentRowIndex}*D${currentRowIndex}`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'PPS': getCell({
      v: dashInsteadOfNullCommon(current.pps),
      z: formats.toFixed4,
      t: 'n',
    }),
  };
  currentRowIndex++;
  return [body];
};

const resetData = (): void => {
  currentRowIndex = 2;
};

let headersForDisplay: string[];
let headersForCurrentCompany: string[];
let currentRowIndex = 2;
